// extracted by mini-css-extract-plugin
module.exports = {"MealCard":"MealCard_MealCard__8YNqP"};